import React, { useMemo, useCallback } from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { useFilters } from '@atlassian/jira-software-backlog-filters-store/src/controllers/filters/main.tsx';
import type { Filters } from '@atlassian/jira-software-filters/src/common/types.tsx';
import FilterSelectionBar from '@atlassian/jira-software-filters/src/ui/filter-selection-bar/index.tsx';
import { CUSTOM_FILTER } from '../../../../model/filters/constants.tsx';
import { filteredCardsRequest } from '../../../../state/actions/cards/filtered-cards/index.tsx';
import { useBacklogSelector, useBacklogDispatch } from '../../../../state/index.tsx';
import { getCardIds } from '../../../../state/selectors/cards/index.tsx';
import { getCMPFilters } from '../../../../state/selectors/filters/index.tsx';

const FilterSelectionBarContainer = () => {
	const [selectedFilters, { setFilters }] = useFilters();
	const allFilters = useBacklogSelector(getCMPFilters);
	const cardIds = useBacklogSelector(getCardIds);

	const dispatch = useBacklogDispatch();

	const onChange = useCallback(
		(filters: Filters, analyticsEvent: UIAnalyticsEvent) => {
			dispatch(filteredCardsRequest(cardIds, analyticsEvent, filters[CUSTOM_FILTER]));
			setFilters({ ...selectedFilters, ...filters });
		},
		[selectedFilters, dispatch, cardIds, setFilters],
	);

	const selectedFilterSet: Set<string> = useMemo(
		() => new Set(selectedFilters[CUSTOM_FILTER]),
		[selectedFilters],
	);

	return (
		<FilterSelectionBar
			selectedFilters={selectedFilterSet}
			onChange={onChange}
			filters={allFilters}
		/>
	);
};

export default FilterSelectionBarContainer;
